import template from './prems-premium-item-iap-list.html.twig';
import './prems-premium-item-iap-list.scss';

Shopware.Component.register('prems-premium-item-iap-list', {
    template: template,

    data() {
        return {
            items: [
                {
                    feature: this.$tc('prems-premium-item.iap.number-of-free-items-shown-in-checkout'),
                    free: 1,
                    advanced: this.$tc('prems-premium-item.iap.unlimited')
                },
                {
                    feature: this.$tc('prems-premium-item.iap.admin-module-to-show-all-premium-items'),
                    free: false,
                    advanced: true
                },
                {
                    feature: this.$tc('prems-premium-item.iap.admin-module-with-statistics'),
                    free: false,
                    advanced: true
                },
                {
                    feature: null,
                    free: null,
                    advanced: null
                }
            ]
        }
    },

    computed: {
        columns() {
            return [
                {
                    property: 'feature',
                    label: this.$tc('prems-premium-item.iap.feature')
                },
                {
                    property: 'free',
                    label: this.$tc('prems-premium-item.iap.free'),
                    align: 'center'
                },
                {
                    property: 'advanced',
                    label: this.$tc('prems-premium-item.iap.advanced'),
                    align: 'center'
                },
            ];
        },

        lastItem() {
            return this.items[this.items.length - 1] || null;
        },

        inAppPurchaseCheckout() {
            return Shopware.Store.get('inAppPurchaseCheckout');
        },

        hideAdvancedButton() {
            return Shopware.InAppPurchase.isActive('PremsPremiumItem', 'premsPremiumItemAdvanced');
        }
    },

    methods: {
        isLastItem(item) {
            return item === this.lastItem;
        },

        onClickBuyIapAdvanced() {
            this.inAppPurchaseCheckout.request({ identifier: 'premsPremiumItemAdvanced' }, 'PremsPremiumItem');
        },

        isBoolean(value) {
            return typeof value === "boolean";
        }
    }
});